<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xvii">Notes on Translation</a></p><a id="page_xvii">
<p class="noindent">I have used both English and Chinese sources for this study. I translated all the Chinese sources used in this study when the English translations were not available or were inaccurate.</p>
<p class="indent">Mao wrote many speeches and essays in different time periods, but the English versions of his selected works were published in later years. In each citation to Mao’s speeches, I give two dates: the year of Mao’s work and the year in which the English translation was published. For example, I use “Mao 1937/1967” to indicate that the speech was written in 1937 and the translation was published in 1967.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Fm03.vue?995bc3aa